module.exports = __webpack_public_path__ + "img/by-nc-sa.eu.f5eff424.png";